"use client";
import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { useEffect } from "react";

interface PostHogProviderProps {
  children: React.ReactNode;
}

export function PostHogProvider({ children }: PostHogProviderProps) {
  useEffect(() => {
    const key = process.env.NEXT_PUBLIC_POSTHOG_KEY || "";
    const host = process.env.NEXT_PUBLIC_POSTHOG_HOST || "";
    posthog.init(key, {
      api_host: "/api/internal/a", // Routes general events and recordings through the proxy
      flags_api_host: "/api/internal/f", // Routes feature flag evaluations through the dedicated proxy
      ui_host: host, // Connects with PostHog for dashboard/toolbar features
      capture_pageview: true, // Send pageview events
      autocapture: true, // Sends device type, browser info, etc.
    } as any);
  }, []);
  return <PHProvider client={posthog}>{children}</PHProvider>;
}
